import { render } from "./TestResults.vue?vue&type=template&id=4d590c96&lang=html"
import script from "./TestResults.vue?vue&type=script&lang=js"
export * from "./TestResults.vue?vue&type=script&lang=js"

import "./TestResults.vue?vue&type=style&index=0&id=4d590c96&lang=css"
script.render = render

export default script